export const APPLICATION_NAME = 'Priority Services';
export const MAIN_URL = 'http://www.yorkshirewater.com';
export const AUTH = { IDENTIFIER: null };
export const APP_BASENAME = process.env.NODE_ENV === 'production' ? '#{AppBaseName}' : '';

export { default as API } from './api';
// export { API_BASE_URL, API_ENDPOINTS, BASE_URL } from './api';
export { default as ROUTES } from './routes';
export { default as TELEMETRY } from './telemetry';

export { authOptions } from './authOptions';
